import {
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiClock,
  FiPause,
  FiPlay,
} from "react-icons/fi";
import dayjs from "dayjs";
import useApp from "hooks/useApp";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Separator } from "@/components/ui/separator";
import moment from "moment";
import "moment-timezone";

import { useState, useEffect } from "react";
import classNames from "utilities/ClassNames";
import { MdInfoOutline } from "react-icons/md";

export default function Info() {
  const { dateTime, setDateTime, isScaled } = useApp();

  const [open, setOpen] = useState(false);
  const [date, setDate] = useState<any>(new Date());
  const [selectedTime, setSelectedTime] = useState<any>(null);

  useEffect(() => {
    if (selectedTime && date) {
      const newDate = date.setHours(selectedTime.h, selectedTime.m, 0);
      setDate(new Date(newDate));
      setDateTime(new Date(newDate));
    }
  }, [selectedTime]);
  return (
    <div className="relative mr-5">
      {open && (
        <div
          className="fixed z-10 inset-0 w-full h-full bg-transparent"
          onClick={() => setOpen(false)}
        />
      )}
      <div className="relative z-20">
        <Popover open={open}>
          <PopoverTrigger
            asChild
            className="text-white cursor-pointer"
            onClick={() => setOpen(true)}
          >
            <div className="cursor-pointer hover:text-green">
              <MdInfoOutline size={isScaled ? 28 : 22} />
            </div>
          </PopoverTrigger>
          <PopoverContent
            className={classNames(
              isScaled ? "text-xl" : "text-base",
              "w-auto bg-black mt-5 p-0"
            )}
            align="center"
          >
            <div className="min-w-[800px] h-[700px] overflow-hidden overflow-y-scroll pl-3 pt-3 pb-3">
              <h1 className="text-green font-bold text-2xl">Key Guide</h1>
              <div className="mt-5">
                {/* titles */}
                <div className="flex">
                  <div className="flex-1 underline">Action</div>
                  <div className="flex-1 underline">Keyboard/Mouse</div>
                </div>
                {/* one */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-40">
                      <p>Horizontal Movement</p>
                    </div>
                    <div className="flex gap-3">
                      <div className="w-7 h-7 grid place-content-center bg-green text-white rounded-md">
                        a
                      </div>
                      <div className="w-7 h-7 grid place-content-center bg-green text-white rounded-md">
                        d
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p>a - left, d - right</p>
                  </div>
                </div>
                {/* two */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-40"></div>
                    <div className="flex gap-3">
                      <div className="w-7 h-7 grid place-content-center bg-green text-white rounded-md">
                        <FiChevronLeft />
                      </div>
                      <div className="w-7 h-7 grid place-content-center bg-green text-white rounded-md">
                        <FiChevronRight />
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p>left-arrow - left, right-arrow - right</p>
                  </div>
                </div>
                {/* divider */}
                <div className="w-full h-[1px] bg-lightGray mt-5" />

                {/* three */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-40">
                      <p>Vertical Movement</p>
                    </div>
                    <div className="flex gap-3">
                      <div className="w-7 h-7 grid place-content-center bg-green text-white rounded-md">
                        w
                      </div>
                      <div className="w-7 h-7 grid place-content-center bg-green text-white rounded-md">
                        d
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p>w - forward, s - backward</p>
                  </div>
                </div>
                {/* four */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-40"></div>
                    <div className="flex gap-3">
                      <div className="w-7 h-7 grid place-content-center bg-green text-white rounded-md">
                        <FiChevronUp />
                      </div>
                      <div className="w-7 h-7 grid place-content-center bg-green text-white rounded-md">
                        <FiChevronDown />
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p>up-arrow - forward, down-arrow - backward</p>
                  </div>
                </div>
                {/* divider */}
                <div className="w-full h-[1px] bg-lightGray mt-5" />

                {/* five */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-40">
                      <p>Fly</p>
                    </div>
                    <div className="flex gap-3">
                      <div className="w-7 h-7 grid place-content-center bg-green text-white rounded-md">
                        f
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p>f - to fly</p>
                  </div>
                </div>
                {/* divider */}
                <div className="w-full h-[1px] bg-lightGray mt-5" />

                {/* six */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-40">
                      <p>Lock Flying</p>
                    </div>
                    <div className="flex gap-3">
                      <div className="w-7 h-7 grid place-content-center bg-green text-white rounded-md">
                        l
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p>l - to lock the flying height</p>
                  </div>
                </div>
                {/* divider */}
                <div className="w-full h-[1px] bg-lightGray mt-5" />

                {/* seven */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-32">
                      <p>Medium Speed</p>
                    </div>
                    <div className="flex gap-1">
                      <p>Movement + </p>
                      <div className="px-1 h-7 grid place-content-center bg-green text-white rounded-md">
                        Left Shift
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p>Movement key + Left Shift</p>
                  </div>
                </div>
                {/* divider */}
                <div className="w-full h-[1px] bg-lightGray mt-5" />

                {/* eight */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-32">
                      <p>High Speed</p>
                    </div>
                    <div className="flex gap-1">
                      <p>Movement + </p>
                      <div className="px-1 h-7 grid place-content-center bg-green text-white rounded-md">
                        Right Shift
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p>Movement key + Right Shift</p>
                  </div>
                </div>
                {/* divider */}
                <div className="w-full h-[1px] bg-lightGray mt-5" />

                {/* nine */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-36">
                      <p>Tags</p>
                    </div>
                    <div className="flex gap-1">
                      <div className="flex items-center gap-1">
                        <p>Mouse</p>
                        <FiChevronRight />
                      </div>
                      <div className="px-1 h-7 grid place-content-center bg-green text-white rounded-md">
                        Left Click
                      </div>
                    </div>
                  </div>
                </div>
                {/* divider */}
                <div className="w-full h-[1px] bg-lightGray mt-5" />

                {/* ten */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-36">
                      <p>Expression LookUp</p>
                    </div>
                    <div className="flex gap-1">
                      <div className="flex items-center gap-1">
                        <p>Mouse</p>
                        <FiChevronRight />
                      </div>
                      <div className="px-1 h-7 grid place-content-center bg-green text-white rounded-md">
                        Right Click
                      </div>
                    </div>
                  </div>
                </div>
                {/* divider */}
                <div className="w-full h-[1px] bg-lightGray mt-5" />

                {/* eleven */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-32">
                      <p>Release cursor</p>
                    </div>
                    <div className="flex gap-1">
                      <div className="px-1 h-7 grid place-content-center bg-green text-white rounded-md">
                        Esc
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p>Escape Key - to release cursor</p>
                  </div>
                </div>
                {/* divider */}
                <div className="w-full h-[1px] bg-lightGray mt-5" />

                {/* seven */}
                <div className="flex mt-5">
                  <div className="flex-1 flex gap-5">
                    <div className="w-32">
                      <p>Lock cursor</p>
                    </div>
                    <div className="flex gap-1">
                      <div className="flex items-center gap-1">
                        <p>Mouse</p>
                        <FiChevronRight />
                      </div>
                      <div className="px-1 h-7 grid place-content-center bg-green text-white rounded-md">
                        Double Click
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p>Click anywhere in the 3d environment</p>
                  </div>
                </div>
                {/* divider */}
                <div className="w-full h-[1px] bg-lightGray mt-5" />
              </div>
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </div>
    // <div className="mr-5 rounded-md p-3 hover:bg-black cursor-pointer flex items-center gap-2">
    //   <span>{dayjs(new Date()).format("MMMM DD,YYYY THH:mm:ss A")}</span>
    //   <span className="text-green">
    //     <FiClock />
    //   </span>
    // </div>
  );
}
